import { GoogleLogin } from '@react-oauth/google';
import { message } from 'antd';
import userStore from '../../zustand/store/userStore';

const GoogleSignInButton = () => {
  const { googleLogin } = userStore();

  return (
    <div className="mt-4">
      <GoogleLogin
        onSuccess={credentialResponse => {
          const { credential } = credentialResponse;
          if (credential) {
            googleLogin(credential);
            message.success('Sign Successfull via Google'); 
          } else {
            console.log("Missing credential");
          }
        }}
        onError={() => {
          console.log('Login Failed');
          message.error('Google login failed'); 
        }}
        shape="pill"
        text="continue_with"
        theme="outline"
        size="large"
        width="300"
      />
    </div>
  );
};

export default GoogleSignInButton;
